"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestType = void 0;
var ContestType;
(function (ContestType) {
    ContestType["TEAM_SURVIVOR"] = "team_survivor";
    ContestType["TEAM_PICK_EM"] = "team_pick_em";
    ContestType["PLAYER_TIER"] = "player_tier";
    ContestType["PLAYER_CATEGORY"] = "player_category";
    ContestType["PLAYER_ONE_AND_DONE"] = "player_one_and_done";
    ContestType["PLAYER_SURVIVOR"] = "player_survivor";
})(ContestType || (exports.ContestType = ContestType = {}));
